// Finish identifiers are an open server-owned contract. The nonfoil identifier
// remains explicit because it has established default-selection and wire
// semantics throughout the card data model.
export type FinishEnum = string;
export const NONFOIL_FINISH: FinishEnum = "nonfoil";

export enum CardLanguageEnum {
  English = "English",
  AncientGreek = "Ancient Greek",
  Arabic = "Arabic",
  ChineseSimplified = "Chinese Simplified",
  ChineseTraditional = "Chinese Traditional",
  French = "French",
  German = "German",
  Hebrew = "Hebrew",
  Italian = "Italian",
  Japanese = "Japanese",
  Korean = "Korean",
  Latin = "Latin",
  Phyrexian = "Phyrexian",
  PortugueseBrazil = "Portuguese (Brazil)",
  Russian = "Russian",
  Sanskrit = "Sanskrit",
  Spanish = "Spanish",
}

export enum CardConditionEnum {
  _,
  Poor,
  Played,
  LightPlayed,
  Good,
  Excellent,
  NearMint,
  Mint,
}
